import { redirect } from "react-router-dom";
import { updateRental } from "../../../data/loca/rentals";

export async function action({ params }) {
    await updateRental(params.rentalId, 'Done');
    return redirect(`/${params.rentalId}`);

}